import CodeBlock from "./code-block";

export default CodeBlock;
